module.exports = __webpack_public_path__ + "static/media/06.0a06e8fb.png";